<template>
    <section class="module" :class="css.container">
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <h2 :class="css.title" class="font-variable color-1 font-bold">{{ $t("References") }}</h2>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/e241fc40-09db-4315-8a3f-531239baa4bf.webp" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("GeneReferencesDescript1") }}</div>
                        <div :class="css_normalize.context">{{ $t("GeneReferencesDescript2") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <related-references :id="$route.params.id?.toString()" mode="gene" />
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltip } from "various-ui";
//* 局部公共组件
import RelatedReferences from "@/views/details/components/related-references/index.vue";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";
</script>

<style lang="less" scoped>
section.module {
    padding-bottom: 160px;
    .module-not {
        margin-top: 40px;
    }
}
</style>
